(function (window, document) {

    document.addEventListener('DOMContentLoaded', function () {
        document.body.addEventListener('click', function (e) {
            // toggle buttons
            if (e.target.classList.contains('js-toggle')) {
                if (window.matchMedia('(min-width: 64rem').matches) {
                    return false;
                }
                e.target.blur();
                toggleGroup(e.target);
            }

            if (e.target.classList.contains('js-switch')) {
                if (!window.matchMedia('(min-width: 64rem').matches) {
                    e.preventDefault();
                }
                e.target.blur();
                switchGroup(e.target);
            }

            if (e.target.classList.contains('js-mobile-nav-toggle')) {
                document.querySelector('.header--main').classList.toggle('is-active');
            }
        });
    });

    var formValidationError = document.querySelectorAll('.validation_error');
    if (typeof formValidationError !== 'undefined' && formValidationError.length > 0) {
        window.location.hash = 'solliciteer-direct';
        formValidationError[0].scrollIntoView({behaviour: 'smooth', block: 'start'});
    }

    function toggleGroup(showEl) {
        var target = document.querySelector('.js-toggle-target[data-toggle="' + showEl.dataset.toggle + '"]');
        target.classList.toggle('is-active');
        showEl.classList.toggle('is-active');
        showEl.scrollIntoView({behaviour: 'smooth', block: 'start'});
    }

    function switchGroup(showEl) {
        document.querySelectorAll('.js-switch-target.is-active').forEach(function (e) {
            e.classList.remove('is-active');
        });

        document.querySelectorAll('.js-switch').forEach(function (e) {
            e.classList.remove('is-active');
        });

        var target = document.querySelector('.js-switch-target[data-switch="' + showEl.dataset.switch + '"]');
        target.classList.add('is-active');
        showEl.classList.add('is-active');
    }

}(window, document));

import Swiper, { Navigation, Pagination } from 'swiper';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);

const slider = document.querySelector('.swiper');

if(slider) {

    const swiper = new Swiper('.swiper', {

        slidesPerView: 1,
        direction: 'horizontal',
        loop: true,
        spaceBetween: 20,
        centeredSlides: false,
        
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        breakpoints: {

            720: {
                slidesPerView: 2,
            }, 
            1000: {
                slidesPerView: 3,
                spaceBetween: 20,
            }
        }
    });
    
}